import { render } from "./buttongroup.vue?vue&type=template&id=c9d1bb1c"
import script from "./buttongroup.vue?vue&type=script&lang=js"
export * from "./buttongroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__